import * as React from 'react';
import SiteThemeProvider from '../../src/themes/ThemeProviders/SiteThemeProvider';

export const wrapRootElement = ({ element }) => <SiteThemeProvider>{element}</SiteThemeProvider>;
